import { IPersonBadge } from "../../../../common/types";
import { FormValues as NewBadge } from "../../../createBadge/utils/types";
import { BadgePaymentStatus, BadgeStatuses } from "../../../../common/enums";
import QRUtils from "../../details/download/utils/utils";

const areBadgesTheSame = (prevBadge: IPersonBadge | undefined, nextBadge: IPersonBadge | undefined) => {
  if (!prevBadge || !nextBadge) {
    return true;
  }
  const { supportStaffDetails: prevStaffDetails } = prevBadge;
  const { supportStaffDetails: nextStaffDetails } = nextBadge;

  const { firstName, jobTitle, email, lastName } = prevBadge.contact;
  const { firstName: nextFirst, lastName: nextLast, email: nextEmail, jobTitle: nextJob } = nextBadge.contact;
  return (
    JSON.stringify([
      firstName,
      jobTitle,
      email,
      lastName,
      prevBadge.customerType,
      prevBadge.productCode,
      prevBadge.status,
      prevBadge.organisation.displayName,
      prevBadge.badgeVersion,
      ...Object.values(prevStaffDetails)
    ]) ===
    JSON.stringify([
      nextFirst,
      nextJob,
      nextEmail,
      nextLast,
      nextBadge.customerType,
      nextBadge.productCode,
      nextBadge.status,
      nextBadge.organisation.displayName,
      nextBadge.badgeVersion,
      ...Object.values(nextStaffDetails)
    ])
  );
};

const getTransformedInfoFromNewBadge = (
  newBadge: NewBadge,
  gbsCode: string,
  secret: string,
  badgeLocation: string,
  registrationId?: string,
  badgeToken?: string
): IPersonBadge => {
  const { id, personInfo, orgInfo } = newBadge;

  const qrContent = QRUtils.generateQRContentForNewReg(
    gbsCode,
    personInfo.firstName,
    personInfo.badgeType.rx_entitlement_id!,
    secret,
    personInfo.customerType,
    newBadge.id
  );
  const qrContentWithAddons =
    newBadge.addonProductCodes && newBadge.addonProductCodes.length > 0
      ? QRUtils.getUpdatedQrContent(
          qrContent,
          {
            contact: {
              firstName: personInfo.firstName
            },
            customerType: personInfo.customerType,
            addonProductCodes: newBadge.addonProductCodes
          } as IPersonBadge,
          personInfo.badgeType.rx_entitlement_id!,
          secret,
          true,
          [personInfo.badgeType]
        )
      : qrContent;

  return {
    registrationId: registrationId || "",
    badgeToken: badgeToken || "",
    addonProductCodes: newBadge.addonProductCodes,
    id,
    contact: {
      email: personInfo.email,
      lastName: personInfo.lastName,
      jobTitle: personInfo.jobTitle,
      firstName: personInfo.firstName,
      mobilePhone: personInfo.mobilePhone
    },
    eventEditionGbsCode: gbsCode,
    qrCodeContent: qrContentWithAddons,
    status: BadgeStatuses.ACTIVE,
    productCode: personInfo.badgeType.sku,
    customerType: personInfo.customerType,
    badgeLocation,
    marketingPreferencesPromptRequired: false,
    paymentStatus: BadgePaymentStatus.PAID,
    organisation: {
      displayName: orgInfo.companyName,
      standIds: [orgInfo.standsWorkingOn],
      city: orgInfo.city,
      state: orgInfo.state || orgInfo.province,
      countryCode: orgInfo.country,
      participatingOrganisationId: orgInfo.id || null
    },
    supportStaffDetails: {
      companyName: orgInfo.companyName,
      companyAddress: orgInfo.address,
      mobilePhone: personInfo.onsiteMobileNumber || "",
      userAccess: personInfo.userAccess,
      stands: orgInfo.standsWorkingOn,
      reportsTo: personInfo.reportsTo
    }
  };
};

const SearchPageUtils = {
  areBadgesTheSame,
  getTransformedInfoFromNewBadge
};

export default SearchPageUtils;
